// extracted by mini-css-extract-plugin
export var phone = "Phone-module--phone--2QJx4";
export var phonePrimary = "Phone-module--phone--primary--1Mui4";